export enum RefusalTypeFlags {
  'OTHER' = 'OTHER',
  'NON_COMPETITIVE' = 'NON_COMPETITIVE',
  'NON_DIFFERENTIATED' = 'NON_DIFFERENTIATED',
  'KNOWN_COMPANY' = 'KNOWN_COMPANY',
}
